import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '..';
import { FormulaFields, PromptType } from './types';

export const selectSelf = (state: RootState) => state.ai;

export const selectGenres = createSelector(selectSelf, ({ genres }) => genres);

export const selectPrimaryGenre = createSelector(
  selectSelf,
  ({ primaryGenre }) => primaryGenre
);

export const selectFormula = createSelector(
  selectSelf,
  ({ formula }) => formula
);

export const selectMicroGenre = createSelector(
  selectSelf,
  ({ microGenre }) => microGenre
);

export const selectCurrentPromptType = createSelector(
  selectSelf,
  ({ promptType }) => promptType
);

export const selectCurrentTextPrompt = createSelector(
  selectSelf,
  ({ textPrompt }) => textPrompt
);

export const selectPlaceholderPrompt = createSelector(
  selectSelf,
  ({ placeholderPrompt }) => placeholderPrompt
);

export const selectMicroGenres = (genreName: string) =>
  createSelector(
    [selectGenres],
    (genres) =>
      genres.find((genre) => genre.name === genreName)?.microGenres ?? []
  );

export const selectUploadedAudio = createSelector(selectFormula, (formula) =>
  formula.find(({ field }) => field === FormulaFields.UserLoop)
);

export const selectHasUploadedAudio = createSelector(
  selectUploadedAudio,
  (audioField) => !!audioField
);

export const selectCurrentPrompt = createSelector(
  [
    selectCurrentPromptType,
    selectFormula,
    selectPrimaryGenre,
    selectMicroGenre,
    selectCurrentTextPrompt,
    selectPlaceholderPrompt,
  ],
  (
    promptType,
    formula,
    primaryGenre,
    microGenre,
    textPrompt,
    placeholderPrompt
  ) => {
    if (promptType === PromptType.TextToMusic) {
      return {
        promptType,
        text: textPrompt || placeholderPrompt,
        formula,
      };
    }

    if (!primaryGenre) {
      return null;
    }

    return {
      promptType,
      primaryGenre,
      microGenre,
      formula,
    };
  }
);
